import React, { useState } from 'react';
import { Button } from '../../ui/button';
import { ExternalLink, ChevronRight, Copy, Check } from 'lucide-react';

// Emergent Prompt Card Component - Contains ALL generated code
export const EmergentPromptCard = ({ prompt, copiedItems, copyToClipboard }) => {
  const [isExpanded, setIsExpanded] = useState(false);
  const codeCount = (prompt.match(/```/g) || []).length / 2;

  return (
    <div className="mb-3 bg-gradient-to-r from-purple-900/30 to-pink-900/30 border border-purple-500/30 rounded-xl overflow-hidden">
      <button
        onClick={() => setIsExpanded(!isExpanded)}
        data-testid="export-emergent-toggle"
        className="w-full p-3 flex items-center justify-between text-left hover:bg-purple-500/10 transition-colors"
      >
        <div className="flex items-center gap-2">
          <div className="w-7 h-7 bg-gradient-to-br from-purple-500 to-pink-500 rounded-lg flex items-center justify-center">
            <ExternalLink className="w-3.5 h-3.5 text-white" />
          </div>
          <div>
            <span className="text-purple-300 font-semibold text-sm">Export to Emergent</span>
            <p className="text-purple-300/60 text-xs">
              {codeCount > 0 ? `Includes ${codeCount} code file${codeCount > 1 ? 's' : ''} ready to build` : 'Copy complete project blueprint'}
            </p>
          </div>
        </div>
        <ChevronRight className={`w-4 h-4 text-purple-300 transition-transform ${isExpanded ? 'rotate-90' : ''}`} />
      </button>

      {isExpanded && (
        <div className="px-3 pb-3">
          <div className="relative">
            <Button
              onClick={() => copyToClipboard(prompt, 'emergent-prompt')}
              data-testid="copy-emergent-prompt-btn"
              className="absolute top-2 right-2 bg-purple-500 hover:bg-purple-600 text-white rounded-full px-3 py-1.5 text-xs z-10 font-medium"
            >
              {copiedItems['emergent-prompt'] ? (
                <><Check size={12} className="mr-1" />Copied!</>
              ) : (
                <><Copy size={12} className="mr-1" />Copy All Code</>
              )}
            </Button>
            <div className="bg-[#1a1c1b] rounded-lg p-3 max-h-72 overflow-y-auto">
              <pre className="text-[#888680] text-xs font-mono whitespace-pre-wrap">{prompt}</pre>
            </div>
          </div>
          <p className="text-purple-300/60 text-xs mt-2 text-center">
            Paste this into Emergent to build your complete app with all the generated code
          </p>
        </div>
      )}
    </div>
  );
};
